export const WHATSAPP_NUMBER = "919288492475";
export const WHATSAPP_DISPLAY = "+91 92884 92475";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi Nivaan Experiences, I'd like to plan a journey. I'd like to know more about your personalized travel planning service."
)}`;
export const EMAIL = "nivaanexperiences@gmail.com";
export const INSTAGRAM_HANDLE = "@nivaanexperiences";
export const INSTAGRAM_LINK = "https://instagram.com/nivaanexperiences";
export const TAGLINE = "Every Journey. Personally Managed.";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
